<script>
	const page = require('page');
	module.exports = {
		beforeCreate() {
			let search = window.location.search;
			let hash = window.location.hash;
			let contentTab = 'contentTab:scope-and-sequence';

			if (hash) {
				hash += '/' + contentTab;
			} else {
				hash = '#!' + contentTab;
			}

			page.redirect(`/find-content${search}${hash}`);
		}
	};
</script>
